module.exports = __webpack_public_path__ + "static/media/cover.3fddc535.jpg";